/* eslint-disable @typescript-eslint/no-explicit-any */
import {Text, View} from '@react-pdf/renderer';
import React from 'react';
import {styles} from './styles';
import { DateToddmmyyyyFormatNoError } from '../../../../data/factory';

export const AssurranceScolaire = (props: any) => {
  const getCurrentDate = () => DateToddmmyyyyFormatNoError(new Date());
  const {detailContrat} = props;

  return (
    <View>
      <View style={{margin: 10}} />
      <Text style={styles.title}>VOTRE ASSURANCE SCOLAIRE</Text>
      <Text style={styles.title}>CONDITIONS PARTICULIÈRES</Text>
      <Text
        style={{...styles.textBolded, alignSelf: 'flex-end', marginRight: 20}}>
        OPTION 1 : {'  '}
        {detailContrat.primeTTC === '12 000' ? '+' : '-'}12 ans{' '}
      </Text>
      <View style={styles.sousSection}>
        <Text>
          Police N°: {detailContrat.numeroPolice} Assuré N°: {detailContrat.id}{' '}
          Agence : {detailContrat.agence}
        </Text>
        <Text>
          Date d'effet: {detailContrat.dateSouscription} Date d'expiration :{' '}
          {detailContrat.dateEcheance} Rattachement : {detailContrat.agence}
        </Text>
        <Text>
          Souscripteur: {detailContrat.nomPrenomContractant} Éleve assuré :{' '}
          {detailContrat.nomPrenomAssure}
        </Text>
        <Text>
          Adresse: {detailContrat.adresse} Date de naissance :{' '}
          {detailContrat.dateNaissanceAssure}
        </Text>
        <Text>
          Contact: {detailContrat.telephone} Etablissement scolaire :{' '}
          {detailContrat.etablissementScolaire}
        </Text>
        <Text>
          Email: {detailContrat.emailContractant} Année scolaire :{' '}
          {detailContrat.anneeScolaire}
        </Text>
        <Text style={styles.subtitle1}>1. Responabilité civile :</Text>
        <Text style={styles.subtitle1}>2. Indemnités contractuelles :</Text>
        <Text style={styles.subtitle1}>3. Prime :</Text>
        <Text>
          Le Souscripteur s’engage à payer à la signature du présent contrat la
          prime afférente à la période de la garantie ci- dessus de{'  '}
          <Text style={{...styles.title, fontSize: 10}}>
            {detailContrat.primeTTC === '12 000'
              ? '12 000 Ariary  '
              : '10 000 Ariary  '}{' '}
            TTC
          </Text>
        </Text>
        <Text>
          dont TVA
          <Text style={{...styles.title, fontSize: 10}}>
            {'  '}
            {detailContrat.primeTTC === '12 000' ? '2 000 ' : '1 667 '} Ariary.
          </Text>
        </Text>
        <Text>
          Le Souscripteur et les assurés déclarent sincères les renseignements
          communiqués par eux dans les présentes Conditions Particulières.
        </Text>
        <Text>
          Le Souscripteur reconnaît avoir pris connaissance des Conditions
          annexées au verso et les Conditions Générales Réf. 010 524
        </Text>
        <Text
          style={{...styles.textBolded, alignSelf: 'flex-end', marginTop: 20}}>
          Fait à Antananarivo, le {getCurrentDate()}
        </Text>
        <View style={{margin: 5}} />
        <View style={{flexDirection: 'row'}}>
          <Text style={styles.textBolded}>LE SOUSCRIPTEUR</Text>
          <Text
            style={{
              ...styles.textBolded,
              alignSelf: 'flex-end',
              marginLeft: 300,
            }}>
            L’ASSUREUR{' '}
          </Text>
        </View>
      </View>
    </View>
  );
};
